import { Box } from "@chakra-ui/react"
import { FulfillmentTypes } from "@jackfruit/common"
import React from "react"
import ScrollLinkWrapper from "../scroll-wrappers/ScrollLinkWrapper"
import CardButtonMobileV2 from "./CardButtonMobileV2"
import CardButtonV2 from "./CardButtonV2"

export interface FulfillmentConfig {
  title: string
  description: string
  icon: string
}

interface Props {
  config: FulfillmentConfig
  currentFulfillment: FulfillmentTypes
  fulfillmentType: FulfillmentTypes
  onSetChoice: (fulfillment: FulfillmentTypes) => void
  isDisabled?: boolean
}

const CardButtonWrapperV2: React.FC<Props> = ({
  isDisabled,
  config,
  currentFulfillment,
  onSetChoice,
  fulfillmentType,
}) => {
  const isSelected = currentFulfillment === fulfillmentType

  return (
    <Box flexBasis={0} flexGrow={1}>
      <ScrollLinkWrapper
        toType="nextAction"
        currentBlock="fulfillment"
        offset={0}
        isDisabled={isDisabled}
      >
        <CardButtonV2
          isDisabled={isDisabled}
          config={config}
          isSelected={isSelected}
          onSetChoice={onSetChoice}
          fulfillmentType={fulfillmentType}
        />
        <CardButtonMobileV2
          config={config}
          isDisabled={isDisabled}
          fulfillmentType={fulfillmentType}
          isSelected={isSelected}
          onSetChoice={onSetChoice}
        />
      </ScrollLinkWrapper>
    </Box>
  )
}

export default CardButtonWrapperV2
